export default "__VITE_ASSET__ECa7LQFu__"